// extracted by mini-css-extract-plugin
export default {"row":"StorageAccountLogs_row__XOgDQ","header":"StorageAccountLogs_header__x+GI2","content":"StorageAccountLogs_content__SGbWT"};